export default __webpack_public_path__ + "static/media/file-download-disabled.6f7bce6d.svg";